import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';

@Component({
  selector: 'app-autodraw-dialog',
  templateUrl: './autodraw-dialog.component.html',
  styleUrls: ['./autodraw-dialog.component.scss'],
  imports: [SvgIconComponent],
  standalone: true
})

export class AutodrawDialogComponent{

  constructor(
    public dialogRef: MatDialogRef<AutodrawDialogComponent>
  ) { }

}
